import { PriceType } from "@/core/api/apiClient";

const mapping: Record<PriceType, string> = {
  TonYard: "Ton/Yard",
  Hour: "Hour",
  DeliveryLoad: "Delivery/Load"
};

export function mapPriceType(key: PriceType | string): string {
  return mapping[key as PriceType] ?? key;
}

export default mapPriceType;
